interface AlertType {
  description: string;
}

function Alert({ description }: AlertType) {
  return (
    <div
      className="bg-red-100 border border-red-400 text-red-700 !px-2 py-3 rounded relative m-auto"
      role="alert"
    >
      <span className="block sm:inline ml-1">{description}</span>
    </div>
  );
}

export default Alert;
